module.exports = __webpack_public_path__ + "img/empty-section.db928ee7.svg";